import * as i0 from '@angular/core';
import { Injectable, assertInInjectionContext, inject, Injector, runInInjectionContext } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
const anonymousUser = {
  kind: 'user',
  key: 'anonymous',
  anonymous: true
};
let GenericFeatureFlagService = /*#__PURE__*/(() => {
  class GenericFeatureFlagService {
    static ɵfac = function GenericFeatureFlagService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GenericFeatureFlagService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GenericFeatureFlagService,
      factory: GenericFeatureFlagService.ɵfac,
      providedIn: 'root'
    });
  }
  return GenericFeatureFlagService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Factory function to create a strongly-typed feature flag signal generator.
 *
 * This allows consumers to define their own feature flag key type once,
 * and use the returned function throughout their codebase without repeating the type.
 *
 * @template FeatureFlags - The union type of valid feature flag keys for your application.
 * @param useLive - If true, the signal will update reactively as the flag value changes (using getLiveFeature$).
 *               If false (default), the signal will emit the current value once (using getFeature$).
 * @returns A function that takes a feature flag key, a default value, and optionally an Injector,
 *          and returns a Signal of the feature flag value.
 *
 * @example
 * // Define your flag keys
 * type MyFlags = 'flagA' | 'flagB';
 * // Create a typed signal generator
 * const featureFlagSignal = createFeatureFlagSignal<MyFlags>();
 * // Use in your components/services
 * const flagSignal = featureFlagSignal('flagA', false);
 */
function createFeatureFlagSignal(useLive = false) {
  return function (flag, defaultValue, injector) {
    if (!injector) {
      assertInInjectionContext(createFeatureFlagSignal);
    }
    injector ??= inject(Injector);
    const result = runInInjectionContext(injector, () => {
      const service = inject(GenericFeatureFlagService);
      return useLive ? service.getLiveFeature$(flag, defaultValue) : service.getFeature$(flag, defaultValue);
    });
    return toSignal(result, {
      initialValue: defaultValue
    });
  };
}
class GenericFeatureFlagUserIdentificationService {}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const suppressLdErrors = error => {
  // https://support.launchdarkly.com/hc/en-us/articles/12998125691419-Error-LaunchDarklyFlagFetchError-network-error
  const ignoredErrors = ['LaunchDarklyFlagFetchError'];
  if (!ignoredErrors.includes(error.name)) {
    console.error('[LaunchDarkly Error]', error);
  }
};

/**
 * Generated bundle index. Do not edit.
 */

export { GenericFeatureFlagService, GenericFeatureFlagUserIdentificationService, anonymousUser, createFeatureFlagSignal, suppressLdErrors };
